function decodeJwtPayload(token) {
    try {
        const payload = token.split('.')[1];
        const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
        const json = decodeURIComponent(
            atob(base64)
                .split('')
                .map((c) => '%' + c.charCodeAt(0).toString(16).padStart(2, '0'))
                .join('')
        );
        return JSON.parse(json);
    } catch {
        return null;
    }
}
const Session = {
    getToken() {
        const token = localStorage.getItem('token');
        if (token) return token;
        else return null;
    },

    // Returns true only if a token exists AND its exp claim is in the future.
    isTokenValid() {
        const token = this.getToken();
        if (!token) return false;
        const payload = decodeJwtPayload(token);
        if (!payload?.exp) return false;
        return payload.exp * 1000 > Date.now();
    },

    getRole() {
        const usersRole = localStorage.getItem('usersRole');
        if (usersRole) return usersRole;
        else return null;
    },

    getUserId() {
        const userId = localStorage.getItem('userId');
        if (userId) return userId;
        else return null;
    },

    getUserName() {
        const userName = localStorage.getItem('userName');
        if (userName) return userName;
        else return null;
    },

    setUserSession(userName, token, userId, usersRole) {
        localStorage.setItem('userName', userName);
        localStorage.setItem('token', token);
        localStorage.setItem('userId', userId);
        localStorage.setItem('usersRole', usersRole);
    },

    removeUserSession() {
        localStorage.removeItem('userName');
        localStorage.removeItem('token');
        localStorage.removeItem('userId');
        localStorage.removeItem('usersRole');
    }
}

export default Session;